import { render, staticRenderFns } from "./VesselList.vue?vue&type=template&id=f6187b96&scoped=true&"
import script from "./VesselList.vue?vue&type=script&lang=js&"
export * from "./VesselList.vue?vue&type=script&lang=js&"
import style0 from "./VesselList.vue?vue&type=style&index=0&id=f6187b96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6187b96",
  null
  
)

export default component.exports